
import React, { Component } from 'react';
import {Link} from 'react-router-dom';


export default class CallButton extends Component {
  render() {
    return (
      <div>
        <a href="tel:1+254339-1359" id="caller"><img src="./images/phone.png" className="img-fluid" alt="call" /></a>

      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/CallButton.js